// 公共请求放在这里
import HttpRequest from '@/request'
const API = {
  FileByRecordId:'/front/supervision/v1/supervisionEnergyUtilization/energyUtilizationReport', // 能源利用状况报告查看
  FileType:'/front/supervision/v1/supervisionFileType/listWithFiles', // 获取文件类型列表(带文件列表信息)  
  getlawenforcer:'/front/supervision/v1/supervisionUserInfo/list', // 执法及通知书下达人下拉
  getListAll:'/front/energygov/v1/supervisionUserInfo/list', // 执法级通知书下达人回显
  getByCusrId:'/front/energygov/v1/supervisionEnterpriseRelation/list', // 获取企业列表
  REAL_FILE:'/front/energygov/v1/supervisionFile/decryptUrl',// obs文件解密接口
  FILE_PUBLIC:'/front/energygov/v1/supervisionFile/publicFolder'//公共文件桶
}
/** 获取企业列表 */
export function getByCusr() {
  return HttpRequest({
    url: API.getByCusrId,
    method: 'get'
  })
}
/** 文件查看 */
export function FileToView(data: any) {
  return HttpRequest({
    url: API.FileByRecordId,
    method: 'get',
    params:data
  })
}

/** 文件解密 */
export function getRrealFile(data: any) {
  return HttpRequest({
    url: API.REAL_FILE+'?url='+data.url,
    method: 'get',
  })
}

/** 获取文件类型列表 */
export function FileTypeList(data: any) {
  return HttpRequest({
    url: API.FileType,
    method: 'get',
    params:data
  })
}
/** 获取下拉 */
export function getselectVlaue() {
  return HttpRequest({
    url: API.getlawenforcer,
    method: 'get'
  })
}
/** 获取回显 */
export function getselectAllVlaue() {
  return HttpRequest({
    url: API.getListAll,
    method: 'get'
  })
}

/** 获取回显 */
export function uploadToPublicFolder(data:any) {
  return HttpRequest({
    url: API.FILE_PUBLIC,
    method: 'post',
    data
  })
}


